import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '../../../../elements/Link';
import countries from '../../../../../../data/countries';
import { StyledCopyrightMenu, StyledCopyrightLabel, StyledCopyrightMenuList } from './styles';
import FooterPL from './FooterPL';

const DS_FooterCopyrightMenu = ({ label, items }) => {
  const country = countries[process.env.GATSBY_COUNTRY_CODE];
  const isPoland = country.lang === 'pl';
  const isGB = country.lang === 'en-GB';

  const filteredItems = items.filter(item => {
    if (isGB && item.title === 'Imprint') return false;
    if (isPoland && item.title === 'Dane firmy') return false;
    return true;
  });

  return (
    <>
      {isPoland && <FooterPL />}
      <StyledCopyrightMenu>
        <StyledCopyrightLabel>
          <Typography variant="DS_copySmallRegular">{label}</Typography>
        </StyledCopyrightLabel>
        <StyledCopyrightMenuList>
          {filteredItems.map(item => (
            <Link key={item.id} url={item.url} type={item.type}>
              <Typography component="span" variant="DS_copySmallBold">
                {item.title}
              </Typography>
            </Link>
          ))}
        </StyledCopyrightMenuList>
      </StyledCopyrightMenu>
    </>
  );
};

export default DS_FooterCopyrightMenu;
